import SubscriptionPlan from "../Components/Subscription/SubscriptionPlan";
import NativeSubscriptionPlan from "../Components/Subscription/NativeSubscriptionPlan";
import Headline from "../Components/Elements/Headline";
import { useLanguage } from "../context/LanguageContext";
import PageContentContainer from "../Components/ContentContainers/PageContentContainer";
import { useAuthContext } from "../context/context";
import { Capacitor } from "@capacitor/core";

const Pricing = () => {
  const { copy } = useLanguage();
  const { userData } = useAuthContext();
  const isNative = Capacitor.isNativePlatform();

  return (
    <PageContentContainer>
      <div className="flex flex-col items-center gap-8 md:pt-10">
        <Headline
          headline={copy.pricing.headline}
          description={copy.pricing.description}
          center
        />
        {isNative ? (
          <NativeSubscriptionPlan hasActiveSubscription={userData?.hasActiveSubscription} />
        ) : (
          <SubscriptionPlan hasActiveSubscription={userData?.hasActiveSubscription} />
        )}
      </div>
    </PageContentContainer>
  );
};

export default Pricing;
